import {LogLevelAwareConfig} from './log-level-aware-config';
import {ConsoleAppenderConfig} from './appenders/console/console-appender-config';
import {LocalStorageAppenderConfig} from './appenders/local-storage/local-storage-appender-config';
import {XhrAppenderConfig} from './appenders/xhr/xhr-appender-config';
import {SentryBreadcrumbsAppenderConfig} from './appenders/sentry-breadcrumbs/sentry-breadcrumbs-appender-config';

export class LoggerConfig extends LogLevelAwareConfig {
  /**
   * Number of previous log messages processed as context.
   * Should be greater than contextSize in appenders.
   */
  contextSize = 200;

  /**
   * Console appender
   */
  console = new ConsoleAppenderConfig();

  /**
   * localStorage appender
   */
  localStorage = new LocalStorageAppenderConfig();

  /**
   * XHR appender
   */
  xhr = new XhrAppenderConfig();

  /**
   * Sentry Breadcrumbs appender
   */
  sentryBreadcrumbs = new SentryBreadcrumbsAppenderConfig();
}
